<template>
    <modal :show.sync=show modalClasses="large-sized-modal" headerClasses="pb-0" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500 text-center">Net Income Detail</h3>
        <div class="table-simple-modal">
            <b-table-simple responsive bordered>
                <b-thead>
                    <b-tr>
                        <b-th class="w-100">Income</b-th>
                        <b-th>Before <br/> Amount (RM)</b-th>
                        <b-th>After <br/> Amount (RM)</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
									<b-tr v-if="_gHlp.getValue(detailInflow,'company_bank_statement.amount_before',0) > 0">
										<b-td>Company Bank Statement</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'company_bank_statement.amount_before',0) | moneyFormatter }}</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'company_bank_statement.amount_after',0) | moneyFormatter }}</b-td>
									</b-tr>
									<b-tr v-else>
										<b-td>Salary</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'monthly_salary.amount_before',0) | moneyFormatter }}</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'monthly_salary.amount_after',0) | moneyFormatter }}</b-td>
									</b-tr>
									<b-tr>
										<b-td>Fixed Allowance</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'fixed_allowance.amount_before',0) | moneyFormatter }}</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'fixed_allowance.amount_after',0) | moneyFormatter }}</b-td>
									</b-tr>
									<b-tr>
										<b-td>Avg Variable Income</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'av_var_inc.amount_before',0) | moneyFormatter }}</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'av_var_inc.amount_after',0) | moneyFormatter }}</b-td>
									</b-tr>
									<b-tr>
										<b-td>Avg Commission</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'av_com_inc.amount_before',0) | moneyFormatter }}</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'av_com_inc.amount_after',0) | moneyFormatter }}</b-td>
									</b-tr>
									<b-tr>
										<b-td>Avg Bonus</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'av_bonus_inc.amount_before',0) | moneyFormatter }}</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'av_bonus_inc.amount_after',0) | moneyFormatter }}</b-td>
									</b-tr>
									<b-tr>
										<b-td>Rental Income</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'total_rental_inc.amount_before',0) | moneyFormatter }}</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'total_rental_inc.amount_after',0) | moneyFormatter }}</b-td>
									</b-tr>
									<b-tr>
										<b-td>Other Income</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'total_other_inc.amount_before',0) | moneyFormatter }}</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'total_other_inc.amount_after',0) | moneyFormatter }}</b-td>
									</b-tr>
									<b-tr>
										<b-th>Gross Income</b-th>
										<b-th>{{ _gHlp.getValue(detailInflow,'gross_income.amount_before',0) | moneyFormatter }}</b-th>
										<b-th>{{ _gHlp.getValue(detailInflow,'gross_income.amount_after',0) | moneyFormatter }}</b-th>
									</b-tr>
									<b-tr>
										<b-td>Income Tax</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'income_tax.amount_before',0) | moneyFormatter }}</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'income_tax.amount_after',0) | moneyFormatter }}</b-td>
									</b-tr>
									<b-tr>
										<b-td>EPF</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'epf.amount_before',0) | moneyFormatter }}</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'epf.amount_after',0) | moneyFormatter }}</b-td>
									</b-tr>
									<b-tr>
										<b-td>SOCSO</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'sosco.amount_before',0) | moneyFormatter }}</b-td>
										<b-td>{{ _gHlp.getValue(detailInflow,'sosco.amount_after',0) | moneyFormatter }}</b-td>
									</b-tr>
									<b-tr class="bg-grey">
										<b-th>Net Income</b-th>
										<b-th :class="_gHlp.getNumberColorClass(_gHlp.getValue(detailInflow,'net_income.amount_before',0))">{{ _gHlp.getValue(detailInflow,'net_income.amount_before',0) | moneyFormatter }}</b-th>
										<b-th :class="_gHlp.getNumberColorClass(_gHlp.getValue(detailInflow,'net_income.amount_after',0))">{{ _gHlp.getValue(detailInflow,'net_income.amount_after',0) | moneyFormatter }}</b-th>
									</b-tr>
								</b-tbody>
            </b-table-simple>
        </div>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"

export default {
    props:{
        show_total_inflow: Boolean,
        detailInflow: null,
    },
    components: {
        Modal,
    },
    computed: {
        show: {
            get() {
                return this.show_total_inflow;
            },
            set(newVal) {
                this.$emit('update:show_total_inflow', newVal);
            },
        },
    },
    data() {
        return {
            tableData: {
                data: [],
                total: {},
            },
        }
    }
}
</script>